import PurchaseLinkButtons from './PurchaseLinkButtons'

interface PurchaseButtonsProps {
  onAmazonClick: () => void
  onRakutenClick: () => void
  isAmazonSaleActive: boolean
  amazonAvailable: boolean
  rakutenAvailable: boolean
}

export default function PurchaseButtons({
  onAmazonClick,
  onRakutenClick,
  isAmazonSaleActive,
  amazonAvailable,
  rakutenAvailable,
}: PurchaseButtonsProps) {
  return (
    <section className='relative sticky bottom-0 w-full'>
      <div className='shadow-line' />
      <div className='p-2 text-center bg-white'>
        <PurchaseLinkButtons
          amazonAvailable={amazonAvailable}
          rakutenAvailable={rakutenAvailable}
          isAmazonSaleActive={isAmazonSaleActive}
          onAmazonClick={onAmazonClick}
          onRakutenClick={onRakutenClick}
        />
      </div>
    </section>
  )
}
